export default [
    {
        path: 'usuario-perfil',
        component: () => import(
            /* webpackChunkName: 'cadastro-usuario-perfil' */
            '@/views/cadastro/usuario-perfil/Index'
        ),
        redirect: 'usuario-perfil',
        children: [
            {
                name: 'cadastro-usuario-perfil-index',
                path: '/',
                component: () => import(
                    /* webpackChunkName: 'cadastro-usuario-perfil' */
                    '@/views/cadastro/usuario-perfil/Form.vue'
                ),
            },
        ]
    }
]